import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.css'
import vuetify from './plugins/vuetify'
import VueApexCharts from 'vue-apexcharts'
import "./plugins/vuetify-money.js";
import i18n from './i18n'
import './style/formulate.css'
import VueFormulate from '@braid/vue-formulate'

Vue.config.productionTip = false

Vue.use(VueFormulate)
Vue.use(VueApexCharts)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
